import React from 'react';
import { useReplays } from '~/hooks/live/useReplays';
import { LiveReplays } from '~/components/live/live-replays/LiveReplays';

interface LiveReplaysContainerProps {
  onReplayClick: (id: number) => void;
}

const LiveReplaysContainer: React.FC<LiveReplaysContainerProps> = ({
  onReplayClick,
}) => {
  const { replays, isLoading, isError, checkForMore, hasMore } = useReplays();

  return (
    <LiveReplays
      hasMore={hasMore}
      isError={isError}
      isLoading={isLoading}
      onLoaderIsOnScreen={checkForMore}
      onReplayClick={onReplayClick}
      replays={replays}
    />
  );
};

export { LiveReplaysContainer };
